import React, { HTMLAttributes } from 'react';

import {
  Container,
  Downloads,
} from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ParagraphDownloads as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphDowloadsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphDownloads: React.FC<ParagraphDowloadsProps> = ({
  entity,
}) => {
  const paragraphDownloads = entity.toJS();

  const title = paragraphDownloads.field_title[0]?.value;
  const body = paragraphDownloads.field_body[0]?.processed;
  const downloads = paragraphDownloads.field_downloads;

  const downloadItems = downloads.map((download) => (
    {
      source: download.entity.field_media_document[0].source,
      title: download.entity?.field_caption?.[0]?.value || download.title,
      filename: download.entity.field_media_document[0].filename,
      filesize: download.file_size,
      mime: download.mime_type,
    }
  ));

  return (
    <div className="Paragraph ParagraphDownloads">
      <Container>
        <Downloads
          title={title}
          text={body}
          downloads={downloadItems}
          target="_blank"
        />
      </Container>
    </div>
  );
};

export default ParagraphDownloads;
